import { Puzzle } from 'lucide-react';
import { ResourceGroupOverviewPage } from '../resources/ResourceGroupOverviewPage';

/**
 * Standard overview page for the top-level "Plugins" drill group at
 * `/orgs/${slug}/plugins`. Renders nav cards for every plugin that contributes
 * a page with `group: 'plugins'` (e.g. Replay, Code Server, sandbox tools).
 * Security-oriented plugins (MCP Servers, AI Gateways, Tailscale) use
 * `group: 'security'` and surface under the Security drill instead.
 *
 * The per-org install/uninstall management UI lives under the
 * Organization sub-nav at `/orgs/${slug}/org/plugins` — see
 * `OrgPluginInstallPage`.
 */
export function PluginsOverviewPage() {
  return (
    <ResourceGroupOverviewPage
      icon={<Puzzle className="h-5 w-5 text-muted-foreground" />}
      title="Plugins"
      description="Extend your workspace with optional plugins."
      coreNavItems={[]}
      group="plugins"
      docs="plugins/overview"
    />
  );
}
